export const ChallengeStatus = {
    READY_TO_START: 'READY_TO_START',
    PRE_COOLDOWN_DONE: 'PRE_COOLDOWN_DONE',
    PLAY_TIME_OVER: 'PLAY_TIME_OVER',
    FINAL_DONE: 'FINAL_DONE',
    CANCELLED: 'CANCELLED',
}

export const ParticipantStatus = {
    JOINED: 'JOINED',
    STARTING_SCORE_COLLECTED: 'STARTING_SCORE_COLLECTED',
    PLAYED_FINAL: 'PLAYED_FINAL',
}


export const TransactionType = {
    DEPOSIT: 'DEPOSIT',
    WITHDRAWAL: 'WITHDRAWAL',
    PAYED_CHALLENGE_FEE: 'PAYED_CHALLENGE_FEE',
    REFUNDED_CHALLENGE_FEE: 'REFUNDED_CHALLENGE_FEE',
    CHALLENGE_PAYOUT: 'CHALLENGE_PAYOUT',
    COMMISSION: 'COMMISSION',
    PROMOTION: 'PROMOTION',
    LEADERBOARD_PAYOUT: 'LEADERBOARD_PAYOUT',
    DISCOUNT_CODE: 'DISCOUNT_CODE',

}

export const ChallengeType = {
    FREE: 'FREE',
    PAYED: 'PAYED',
    SPONSORED: 'SPONSORED',
    QUALIFIER: 'QUALIFIER',
    FINAL: 'FINAL'
}

export const WithdrawalStatus = {
    REQUESTED: 'REQUESTED',
    COMPLETE: 'COMPLETE',
    DENIED: 'DENIED',
    FAILED: 'FAILED'
}

export const DepositStatus = {
    CREATED: 'CREATED',
    REQUESTED: 'REQUESTED',
    COMPLETE: 'COMPLETE',
    CANCELLED: 'CANCELLED',
    PENDING: 'PENDING',
}

export const LeaderboardWinnerType = {
    DAILY_SCORE: 'DAILY_SCORE',
    WEEKLY_SCORE: 'WEEKLY_SCORE',
    MONTHLY_SCORE: 'MONTHLY_SCORE'
}

export const DiscountCodeStatus = {
    CREATED: 'CREATED',
    DISTRIBUTED: 'DISTRIBUTED',
    USED: 'USED',
    REVOKED: 'REVOKED'
}

export const HcpType = {
    PRO: 'PRO',
    SINGLE: 'SINGLE',
    HCP_1_18: 'HCP_1_18',
    HCP_19_36: 'HCP_19_36'
}

export const GameType = {
    STABLEFORD: 'STABLEFORD',
    STROKE_PLAY: 'STROKE_PLAY',
    STABLEFORD_NET: 'STABLEFORD_NET',
    STROKE_PLAY_NET: 'STROKE_PLAY_NET'
}

export const PayoutType = {
    CASH: 'CASH',
    MERCHANDISE: 'MERCHANDISE'
}